export default class ApiController{
  Get(){
    throw new Error('[ApiInterface#Get] mandatory')
  }

  Post(){
    throw new Error('[ApiInterface#Post] mandatory')
  }

  Path(){
    throw new Error('[ApiInterface#Path] mandatory')
  }

  Put(){
    throw new Error('[ApiInterface#Put] mandatory')
  }

  Delete(){
    throw new Error('[ApiInterface#Delete] mandatory')
  }
}